import apiService from "./apiService";

const brgyService = {
    async search(searchModel) {
        try {
            const resp = await apiService.get(`brgy/search`, searchModel, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async save(payload) {
        try {
            const resp = await apiService.post(`brgy/save`, payload, true);
            return resp.data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request" };
        }
    },
    async getInfo(id) {
        try {
            const resp = await apiService.get(`brgy/${id}/get-info`, {}, true);
            return resp.data;
        }
        catch {
            return {};
        }
    },
    async getBarangayList() {
        try {
            const resp = await apiService.get(`brgy/get-brgy-list`, {}, true);
            return resp.data;
        }
        catch {
            return [];
        }
    },
    async getClearanceImageById(id){
        try{
            const resp = await apiService.get(`brgy/get-clearance-img/${id}`,{},true);
            return resp.data;
        }
        catch{
            return{img: null};
        }
    }
}

export default brgyService;